import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../PageBuilder/models/form-field.model';

export class ProminenceGroupPickerModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    allowAllOption: boolean;
    headingId?: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        headingId?: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = 'series';
        this.headingId = headingId;
        /* this.label = label;
        this.description = description;
        this.allowAllOption = allowAllOption;*/
    }
}
